import useHttpProvider from "@/common/hooks/use-http";
import { type CarouselApi } from "@/components/ui/carousel";
import { useCallback, useEffect, useState } from "react";
import { Plan } from "../models/plan";
import * as PlanServices from "../services/plans";

function usePlans() {
	const { http } = useHttpProvider();

	const [plans, setPlans] = useState<Plan[]>([]);
	const [api, setApi] = useState<CarouselApi>();
	const [current, setCurrent] = useState(0);

	async function getPlans() {
		const plansResponse = await PlanServices.getPlans(http);
		setPlans(plansResponse);
	}

	useEffect(() => {
		getPlans();
	}, []);

	useEffect(() => {
		if (!api) return;

		setCurrent(api.selectedScrollSnap() + 1);

		api.on("select", () => {
			setCurrent(api.selectedScrollSnap() + 1);
		});
	}, [api]);

	const goTo = useCallback(
		(index: number) => {
			api?.scrollTo(index);
		},
		[api]
	);

	return {
		setApi,
		current,
		goTo,
		plans,
	};
}

export default usePlans;
